import React, { useState, useCallback } from "react";
import api from "../services/api";
import { AttendanceLimitModal } from "../components-v2/AttendanceLimitModal/AttendanceLimitModal";

export function useAttendanceLimit() {
  const [attendanceLimitInfo, setAttendanceLimitInfo] = useState<{ limit: number } | null>(null);

  const checkLimit = useCallback(async () => {
    try {
      const response = await api.get("check_attendance_limit"); 
      const data = response?.data || response;

      if (data && data.canAttend === false) {
        setAttendanceLimitInfo({ limit: data.limit || 8 });
        return false; 
      }
      
      return true; 
    } catch (error) {
      console.error("Erro ao verificar limite:", error);
      return true; 
    }
  }, []);

  const closeLimitModal = useCallback(() => {
    setAttendanceLimitInfo(null);
  }, []);

  const LimitModal = () => {
    if (!attendanceLimitInfo) return null;

    return (
      <AttendanceLimitModal 
        limit={attendanceLimitInfo.limit} 
        onClose={closeLimitModal} 
      />
    );
  };

  return {
    checkLimit,
    LimitModal
  };
}